import React from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import { IC_ROLES } from '../../../base/conference/icRoles';
import { translate } from '../../../base/i18n/functions';
import Dialog from '../../../base/ui/components/web/Dialog';
import { updateTranscriptLink } from '../actions.web';
import { getTranscriptionLink } from '../functions.web';
const useStyles = makeStyles()(() => {
    return {
        transcriptionLinkDialogText: {
            marginBottom: '1em'
        },
        transcriptionLinkDialogInput: {
            width: '100%'
        }
    };
});
const TranscriptLinkDialog = (props) => {
    let transcriptionLink = useSelector(getTranscriptionLink);
    const dispatch = useDispatch();
    const { classes } = useStyles();
    const _onSubmit = () => {
        dispatch(updateTranscriptLink(transcriptionLink ?? ''));
    };
    if (props.isCaptioner) {
        return (React.createElement(Dialog, { cancel: { translationKey: 'Abbrechen' }, ok: { translationKey: 'Speichern' }, 
            // eslint-disable-next-line react/jsx-no-bind
            onSubmit: _onSubmit, size: 'medium', titleKey: 'Lese-Link \u00E4ndern' },
            React.createElement("div", null,
                React.createElement("p", { className: classes.transcriptionLinkDialogText }, "Hier k\u00F6nnen Sie den Lese-Link anpassen."),
                React.createElement("label", { htmlFor: 'transcriptionLink', id: 'transcriptionLinkLabel' }, "Lese-Link"),
                React.createElement("input", { className: classes.transcriptionLinkDialogInput, defaultValue: transcriptionLink, id: 'transcriptionLink', 
                    // eslint-disable-next-line react/jsx-no-bind
                    onChange: event => transcriptionLink = event.target.value, type: 'text' }))));
    }
    return (React.createElement(Dialog, { cancel: { hidden: true }, ok: { hidden: true }, size: 'medium', titleKey: 'Lese-Link' },
        React.createElement("div", null,
            React.createElement("p", null, "Unter folgendem Link k\u00F6nnen Sie das Transkript einsehen:"),
            React.createElement("a", { href: transcriptionLink, rel: 'noreferrer', target: '_blank' }, transcriptionLink))));
};
const _mapStateToProps = (state) => {
    const { conference } = state['features/base/conference'];
    return {
        isCaptioner: conference?.checkLocalHasRole(IC_ROLES.CAPTIONER) ?? false
    };
};
export default translate(connect(_mapStateToProps)(TranscriptLinkDialog));
